export const SPINNING_DOFF_ENTRY_LIST = "spinning_doff_entry_list";
export const SPINNING_DOFF_ENTRY_LIST_SUCCESSFULL = "spinning_doff_entry_list_successfull";
